
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { CategoryVO } from "./vo/category.vo";

@Component
export default class Categories extends Vue {
  currentCateCd = 0;
  categories: Array<CategoryVO> = [];

  // methods
  onCategoryClick(cateCd: number): void {
    this.currentCateCd = cateCd;
  }
  getChildCateCds(parentCateCd: number): Array<CategoryVO> {
    // 자식 category 반환
    const result = this.categories.filter((category) => {
      if (!parentCateCd) {
        return category.cateDepth == 1;
      } else {
        return category.parentCateCd == parentCateCd;
      }
    });
    return result;
  }

  // initialized events
  beforeCreate(): void {
    axios.get("/categories").then((r) => {
      this.categories = r.data as Array<CategoryVO>;
      const depth1 = this.categories.filter((c) => {
        return c.cateDepth == 1;
      });
      depth1 && depth1.length && (this.currentCateCd = depth1[0].cateCd);
    });
  }
}
